import {useQuery} from '@tanstack/react-query'

import {apiGetPaginatedItems} from '../api/memex-items/api-get-paginated-items'
import {buildFilteredItemsCountQueryKey} from '../state-providers/memex-items/queries/query-keys'

/**
 * Makes a request to the paginated items endpoint with
 * a given query string `q` (e.g., "has:assignee")
 * and returns the total count from the response.
 */
export function useFilteredItemsCountQuery(q: string) {
  return useQuery({
    queryKey: buildFilteredItemsCountQueryKey(q),
    queryFn: async () => {
      const response = await apiGetPaginatedItems({q, first: 0})
      return response.totalCount.value
    },
  })
}
